import { useEffect, useState } from "react";
import { getCurrentOrientation } from "../mobile/MobileOrientationManager";
import { DesktopInstrumentLayout } from "./DesktopInstrumentLayout";
import type { InstrumentLayoutProps, OrientationMode } from "./layoutTypes";
import { MobileInstrumentLayout } from "./MobileInstrumentLayout";

function shouldUseMobileLayout(width: number, orientation: OrientationMode): boolean {
  if (width < 900) {
    return true;
  }

  return orientation === "portrait" && width < 1100;
}

export function ResponsiveInstrumentRouter(props: Omit<InstrumentLayoutProps, "orientation">) {
  const [orientation, setOrientation] = useState<OrientationMode>(() => getCurrentOrientation());
  const [width, setWidth] = useState(() => (typeof window === "undefined" ? 1200 : window.innerWidth));

  useEffect(() => {
    const update = () => {
      setOrientation(getCurrentOrientation());
      setWidth(window.innerWidth);
    };
    const media = typeof window.matchMedia === "function" ? window.matchMedia("(orientation: portrait)") : null;

    update();
    window.addEventListener("resize", update);
    media?.addEventListener("change", update);
    window.screen.orientation?.addEventListener?.("change", update);

    return () => {
      window.removeEventListener("resize", update);
      media?.removeEventListener("change", update);
      window.screen.orientation?.removeEventListener?.("change", update);
    };
  }, []);

  const layoutProps: InstrumentLayoutProps = { ...props, orientation };

  return shouldUseMobileLayout(width, orientation) ? (
    <MobileInstrumentLayout {...layoutProps} />
  ) : (
    <DesktopInstrumentLayout {...layoutProps} />
  );
}
